import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Form, InputNumber, notification, Select} from 'antd';

import {getTillLimits, setTillLimit} from './actions';
import {getDescriptionFromError} from "../utils/errors";
import {getDispensaryList} from "../Dispensary/actions";
import {formItemLayout} from "../utils/style";

const FormItem = Form.Item;
const Option = Select.Option;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

function toUniqueTillLimitId(tillLimits) {
  return tillLimits.reduce((cur, {tillLimitId}) => {
    if (cur.indexOf(tillLimitId) < 0) {
      return [...cur, tillLimitId];
    }
    return cur;
  }, []);
}

class SetTillLimitForm extends Component {
  componentDidMount() {
    this.props.getTillLimits();
  }

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {dispensaryId} = this.props;
    e.preventDefault();
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await this.props.setTillLimit({...values, dispensaryId});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, tillLimits} = this.props;
    return (
      <Card title="Set Till Limit">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Till Limit"
          >
            {getFieldDecorator('tillLimitId', {
              initialValue: null
            })(
              <Select>
                <Option key="newTillLimitId" value={null}>New</Option>
                {toUniqueTillLimitId(tillLimits).map(tillLimitId =>
                  <Option key={tillLimitId} value={tillLimitId}>{tillLimitId}</Option>
                )}
              </Select>
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Limit"
          >
            {getFieldDecorator('limit', {
              rules: [{
                required: true,
                message: 'Limit is required'
              }]
            })(
              <InputNumber />
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={hasErrors(getFieldsError())}
              >
                Set Till Limit
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

SetTillLimitForm.propTypes = {
  form: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  setTillLimit: PropTypes.func.isRequired,
  getTillLimits: PropTypes.func.isRequired,
  tillLimits: PropTypes.array.isRequired,
  dispensaryId: PropTypes.string,
};

const SetTillLimitPage = Form.create()(SetTillLimitForm);

const mapStateToProps = state => ({
  dispensaryId: state.dispensary.selectedDispensaryId || null,
  tillLimits: state.tillLimit.tillLimits,
  dispensaryList: state.dispensary.dispensaryList
});

const mapDispatchToProps = dispatch => ({
  setTillLimit: payload => (dispatch(setTillLimit(payload))),
  getTillLimits: () => (dispatch(getTillLimits())),
  getDispensaryList: () => (dispatch(getDispensaryList()))
});

export default connect(mapStateToProps, mapDispatchToProps)(SetTillLimitPage);



// WEBPACK FOOTER //
// ./src/TillLimit/SetTillLimitPage.js